import { render, staticRenderFns } from "./MentorRegistrationIntro.vue?vue&type=template&id=6e5b94fe&scoped=true&"
import script from "./MentorRegistrationIntro.vue?vue&type=script&lang=js&"
export * from "./MentorRegistrationIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5b94fe",
  null
  
)

export default component.exports